import {
    Bell,
    CirclePause,
    Gauge,
    Megaphone,
    PauseCircle,
    PlayCircle,
    SearchCheck,
    SearchX,
    Unplug,
} from "lucide-react";

// Notification type keys MUST match the backend's `type` column exactly.
//
// The backend builds the type as `f"SEQUENCE_{new_status.upper()}"`, so
// for the status `paused_infrastructure_impediment` the emitted type is
// `SEQUENCE_PAUSED_INFRASTRUCTURE_IMPEDIMENT`.
//
// BUGFIX (2026-10-24): the key used to be spelled
// `SEQUENCE_PAUSED_INFRA_IMPEDIMENT` — the word "STRUCTURE" was
// missing — so the infra-impediment notification could never match an
// icon and always fell back to the generic Bell.
//
// The legacy key is kept as an alias so an in-flight notification
// emitted under the old spelling still renders correctly.
const NOTIFICATION_TYPE_CONFIG = {
    SEARCH_COMPLETED: {
        icon: SearchCheck,
    },
    SEARCH_FAILED: {
        icon: SearchX,
    },
    SEQUENCE_COMPLETED: {
        icon: Megaphone,
    },
    // Infra-impediment pause (scheduler-driven).
    SEQUENCE_PAUSED_INFRASTRUCTURE_IMPEDIMENT: {
        icon: CirclePause,
    },
    // Legacy alias for the pre-2026-10-24 misspelling.
    SEQUENCE_PAUSED_INFRA_IMPEDIMENT: {
        icon: CirclePause,
    },
    // User-initiated campaign controls (added 2026-10-24).
    SEQUENCE_PAUSED: {
        icon: PauseCircle,
    },
    SEQUENCE_ACTIVE: {
        icon: PlayCircle,
    },
    CONNECTION_FAILED: {
        icon: Unplug,
    },
    // GATE 2 daily outreach quota reached (added 2026-10-25).
    // The backend emits this when the scheduler skips a tenant whose
    // daily send count reached its tier-derived daily limit. BELL ONLY —
    // no transactional email is sent for this type.
    OUTREACH_SEND_QUOTA_REACHED: {
        icon: Gauge,
    },
};

const FALLBACK_NOTIFICATION_TYPE_CONFIG = {
    icon: Bell,
};

export const getNotificationTypeConfig = (type) => {
    const normalizedType = String(type || "").trim().toUpperCase();

    return (
        NOTIFICATION_TYPE_CONFIG[normalizedType] ||
        FALLBACK_NOTIFICATION_TYPE_CONFIG
    );
};
